import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { HttpClient } from '@angular/common/http';
@Injectable()
export class hodashboardService {
    constructor(private http: HttpClient) { }

    users() {
        this.http.get('https://jsonplaceholder.typicode.com/users');
      }

}
